import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Version = {
    getVersions,
    getEditSongVersions,
    removeSongVersion
}

function getVersions(){
    
    const url = 'song/get-versions.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    };
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function getEditSongVersions(data){
    
    const url = 'song/get-song-versions.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function removeSongVersion(data){
    
    const url = 'song/remove-song-version.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

export default Version